/**
 * @namespace components
 */

import React from 'react';
import PropTypes from 'prop-types';

import { miniGazelle } from '../../../helpers';

import './ProductFeaturesBlock.scss';

/**
 * @class ProductFeaturesBlock
 *
 * Banner module that can be used as an advertising or warning style banner on pages
 *
 * @memberof components
 *
 *
 * @property {object} data - Primary object to insert data props into component
 * @property {string=} data.logicalName - Logical name of the module, used as the HTML node ID
 * @property {array} data.globalMarketingFacts - Array of marketing facts
 * @property {string=} data.globalMarketingFacts.benefit - Benefit title as a string
 * @property {string=} data.globalMarketingFacts.statement - Benefit statement as a string
 *
 * @example
 * return (
 *   <ProductFeaturesBlock data={data} />
 * )
 */

const ProductFeaturesBlock = (props = {}) => {
    const { data = {} } = props;
    const { logicalName = 'product-features', globalMarketingFacts = [] } = data;

    return (
        <div className="container-fluid module product-features" id={logicalName}>
            <div className="row">
                <div className="container">
                    <div className="row">
                        <div className="col-md-2">
                            <h2>{miniGazelle.label('features', true)}</h2>
                        </div>
                        <div className="col-md-10 product-feature-wrapper">
                            <div className="card-columns">
                                {globalMarketingFacts.length > 0 &&
                                    globalMarketingFacts.map((fact = {}, i) => {
                                        const { benefit, statement } = fact;

                                        return (
                                            <div key={i} className="card product-feature">
                                                <div className="inner-content">
                                                    {statement && (
                                                        <h3
                                                            className="h5 product-features-title"
                                                            dangerouslySetInnerHTML={{
                                                                __html: statement,
                                                            }}
                                                        />
                                                    )}
                                                    {benefit && (
                                                        <div
                                                            className=" product-features-benefit"
                                                            dangerouslySetInnerHTML={{
                                                                __html: benefit,
                                                            }}
                                                        />
                                                    )}
                                                </div>
                                            </div>
                                        );
                                    })}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

ProductFeaturesBlock.propTypes = {
    data: PropTypes.shape({
        logicalName: PropTypes.string,
        globalMarketingFacts: PropTypes.arrayOf(
            PropTypes.shape({
                statement: PropTypes.string,
                benefit: PropTypes.string,
            })
        ),
    }),
};

export default ProductFeaturesBlock;
